import SimpleParallax from "simple-parallax-js/vanilla";
export const parallax = () => {

    var images = document.querySelectorAll('.chars__stamp');
   

    new SimpleParallax(images,
        {
            delay: 4,
            orientation: 'down',
            scale: 1.6,
            overflow: true,
        }
    );
};